<template>
	<div class="asic-team-list">
		<div class="asic-team-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Customization ASIC Solutions</span>
			</div>

			<div class="list">
				<div class="dd">
					<p>The Xhorse semiconductor team consists of outstanding members who specialize in the field of
						design, verification, testing, and reliability of semiconductors.  The team has an incredible advantage in several aspects as low-power analog/digital, narrow-band radio frequency communication and algorithm, and security algorithm IP design. With years of unremitting R&D investment, the team has made great achievements in many fields such as RFID/Sub-G transceivers and ultra-low power security IOT MCUs.</p>

					<p>For the sake of the reliable delivery of ASIC products, Xhorse has established an RF
						test&verification laboratory. Keysight and R&S RF instruments produced by mainstream manufacturers, as the core of the laboratory. We can successfully complete the full-link simulation and test platform below 8GHz by the software design of ASIC. We have built a Failure Analysis laboratory equipped with a series of comprehensive failure analysis equipment such as high-performance MPS probe stations and SEM electron microscopes, which can be applied for faster failure analysis and problem-solving, and better improve the quality of semiconductor products.</p>

					<p>The experienced R&D team, precise testing equipment, sophisticated quality control management,
						and multiple reliability tests ensure that our products are safe, reliable, and of excellent quality.</p>
				</div>
				<img :src="solution_image_01" alt="Xhorse"/>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_customization_01.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.list > img {
		width: 100%;
		margin-top: 4rem;
	}

	.dd > p:not(:last-child) {
		margin-bottom: 1.375rem;
	}

	.dd > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.dd {
		width: 100%;
		height: 22.5rem;
	}

	.list {
		width: 54.5rem;
		margin-left: 7rem;
		border: none;
	}

	.asic-team-con {
		width: 61.5rem;
		height: 84.125rem;
		margin-left: 0;
	}

	.asic-team-list {
		width: 100%;
		height: 84.125rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-xhorse-asic-team.vue